import { HeaderCheckout } from './HeaderCheckout.components.styles';

export const HeaderCheckoutLogo = HeaderCheckout.Logo;
export const HeaderCheckoutLogoButton = HeaderCheckout.LogoButton;
